import { Box, Card, CardHeader, CardContent } from '@mui/material';

import { Divider, Button, Typography, Checkboxes } from '@occc-app/design-system';

import { StoreBranding } from './components/store-branding.component';
import { StoreDetails } from './components/store-details.component';
import { StoreLocation } from './components/store-location.component';
import { StoreSchedule } from './components/store-schedule.component';
import {
  RetailerNetworkLocationDetailsValues,
  LocationAddressGeolocation,
} from './retailer-network-location-update-page.types';

import { useRetailerNetworkUserSelector } from '../retailer-network-context/use-retailer-network-user.selector';

type RetailerNetworkLocationUpdateFormProps = {
  hasAddress: boolean;
  disableSubmit: boolean;
  handleSubmit: () => void;
  details: RetailerNetworkLocationDetailsValues;
  geoLocation: LocationAddressGeolocation | null;
  goBack: () => void;
};

export const RetailerNetworkLocationUpdateForm = ({
  geoLocation,
  hasAddress,
  disableSubmit,
  handleSubmit,
  goBack,
}: RetailerNetworkLocationUpdateFormProps) => {
  const { isRetailerNetworkSiteUserRole } = useRetailerNetworkUserSelector();

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={
              <Typography variant='h6' component='h3'>
                Store Details
              </Typography>
            }
          />
          <CardContent>
            <StoreDetails />
          </CardContent>

          <Divider />

          <Typography variant='h6' component='h3' marginLeft={3} marginTop={3}>
            Working Hours
          </Typography>

          <StoreSchedule />

          {!isRetailerNetworkSiteUserRole && (
            <Box ml={3} mb={3}>
              <Checkboxes
                name='applyToAllStores'
                data={{
                  label: 'Apply to all stores in my Network',
                  value: true,
                }}
              />
            </Box>
          )}
        </Card>

        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={
              <Typography variant='h6' component='h3'>
                Location on Map
              </Typography>
            }
          />
          <CardContent>
            <StoreLocation geoLocation={geoLocation} hasAddress={hasAddress} />
          </CardContent>
        </Card>

        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={
              <Typography variant='h6' component='h3'>
                Store Branding
              </Typography>
            }
          />
          <CardContent>
            <StoreBranding />
          </CardContent>
        </Card>

        <Box m={1} display='flex' justifyContent='flex-end' alignItems='flex-end' gap={2}>
          <Button color='primary' onClick={goBack}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={{
              ml: 1,
            }}
            onClick={handleSubmit}
            disabled={disableSubmit}
          >
            Save
          </Button>
        </Box>
      </Box>
    </form>
  );
};
